export enum ErrorPageType {
	NotFound,
	Unauthorize,
	ServerError,
	Forbidden,
}
